// Ce fichier définit les valeurs par defaut du state dans le GlobalContext
// ex: import INITIAL_STATE from '/contexts/INITIAL_STATE';

import I_STATE from './I_STATE';

const INITIAL_STATE: I_STATE = {

  // recuperes du endpoint heelo
  roles:[],
  organisations:[],
  sites:[],
  functions:[],
  referentials:[],
  pagination_limit: 250,
  roles_per_endpoint: {},

  // initial values for import rules
  import_rules: [
    "DEFAULT",
    "OSAC",
    "DIRECTION",
    "POLE",
    "INGNORE"
  ],

  //
  initializationOK: undefined,

  // states de l'app
  drawerShow: false,
  sidebarShow: true,
  panelAlignment: 'vertical',
  paginationUserLimit: 50,

  // infos user
  accessToken: undefined,
  refreshToken: undefined,
  role: undefined,
  function: undefined,
  userId: undefined,
  id_postpone: undefined,
  samlConnecting: false,
  organisationsSets: [],
};
export default INITIAL_STATE;
